import { useEffect, useState } from "react";
import client from "@/lib/glossyApi";
import { Eye, TrendingUp } from "lucide-react";

// Readers panel — S/ME's own cookieless reader counter (GA4 runs alongside once the ID is set).
export default function ReaderStats() {
  const [stats, setStats] = useState(null);
  useEffect(() => { client.get("/admin/stats/readers").then((r) => setStats(r.data)).catch(() => {}); }, []);
  if (!stats) return <p className="font-sans text-sm text-ink/50" data-testid="readers-loading">Counting readers…</p>;
  const max = Math.max(...stats.daily.map((d) => d.views), 1);
  return (
    <div className="space-y-6" data-testid="reader-stats">
      <div>
        <p className="overline text-gloss-gold">Readers</p>
        <p className="font-serif text-3xl mt-1">Who's reading S/ME</p>
        <p className="font-sans text-xs text-ink/55 mt-1">S/ME's own counter — no cookies, counts every page opened on the magazine. Google Analytics adds the deeper detail once connected.</p>
      </div>
      <div className="grid grid-cols-2 gap-4 max-w-md">
        <div className="border border-ink/15 bg-white p-5">
          <p className="overline text-[10px] text-ink/50 flex items-center gap-1.5"><Eye size={12} /> Today</p>
          <p className="font-serif text-4xl mt-1" data-testid="readers-today">{stats.today}</p>
        </div>
        <div className="border border-ink/15 bg-white p-5">
          <p className="overline text-[10px] text-ink/50 flex items-center gap-1.5"><TrendingUp size={12} /> Last 30 days</p>
          <p className="font-serif text-4xl mt-1" data-testid="readers-30d">{stats.total_30d}</p>
        </div>
      </div>
      <div className="border border-ink/15 bg-white p-5">
        <p className="overline text-[10px] text-ink/50 mb-3">Page views · last 30 days</p>
        <div className="flex items-end gap-[3px] h-24" data-testid="readers-chart">
          {stats.daily.map((d) => (
            <div key={d.day} title={`${d.day}: ${d.views}`} className="flex-1 bg-ink/80 hover:bg-gloss-gold transition-colors" style={{ height: `${Math.max((d.views / max) * 100, 2)}%` }} />
          ))}
        </div>
      </div>
      <div className="border border-ink/15 bg-white" data-testid="readers-top">
        <p className="overline text-[10px] text-ink/50 p-4 pb-0">Most read · last 30 days</p>
        <div className="p-4 space-y-2">
          {stats.top.length === 0 && <p className="font-sans text-sm text-ink/45">No views counted yet — numbers start the moment the magazine is live with this update.</p>}
          {stats.top.map((t, i) => (
            <div key={t.path} className="flex items-center gap-3 font-sans text-sm" data-testid={`readers-top-${i}`}>
              <span className="font-mono text-[10px] text-ink/40 w-5">{i + 1}.</span>
              <span className="flex-1 truncate">{t.label}</span>
              <span className="font-mono text-xs text-ink/60">{t.views}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
